import React, { useEffect, useState, useRef } from 'react'
import { clearInput, getData } from './actions'
import { useDebounce } from '@utilities/hooks'
import './style.scss'
import { createList, createTags } from '@modules/admin/groups/actions'
import TextField from '@modules/admin/common/fields/textField'
import { ReactSortable } from 'react-sortablejs'
import Loading from '@modules/core/components/Loading'

const SuggestField = ({
  client,
  label,
  placeholder,
  draggable,
  options,
  input: { value, name, onChange },
  meta,
  ...props
}) => {
  const [display, setDisplay] = useState(false)
  const [search, setSearch] = useState(null)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [, setError] = useState(false)
  // const [dragList, setDragList] = useState(null)
  const inputEl = useRef(null)

  const selectItem = (item) => {
    onChange([...value, item])
    // onChange([...value, item])
    setDisplay(false)
    clearInput(inputEl)
  }
  const deleteItem = (item) => {
    let newTags = value.filter((elem) => elem.id !== item.id)
    onChange(newTags)
  }
  const createListParams = { data: data || options, name: name, selectItem, value: value, setDisplay }
  const tagsParams = { tags: value, name: name, deleteItem }
  const dataParams = { setLoading, setError, setData, client, search }
  const debounceSearch = useDebounce(search, 500)
  useEffect(() => {
    if (debounceSearch !== null) {
      getData(dataParams)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceSearch])
  return (
    <>
      {label && <label>{label}</label>}
      <div className="suggest-field" ref={inputEl}>
        <div className="dropdown">
          {loading && search && <Loading isFetching={true} />}
          <TextField
            placeholder={placeholder}
            value={null}
            onChange={(e) => {
              setSearch(e.target?.value)
              setDisplay(true)
            }}
          />
          {meta?.touched && meta?.error && <span className="error">{meta?.error}</span>}
          {display && search && !!createListParams.data?.length && (
            <div className="list">{createList(createListParams)}</div>
          )}
        </div>
        {draggable ? (
          !!value.length && (
            <ReactSortable className="tag-list" list={value} setList={onChange}>
              {createTags(tagsParams)}
            </ReactSortable>
          )
        ) : (
          <div className="tag-list">{createTags(tagsParams)}</div>
        )}
      </div>
    </>
  )
}
export default SuggestField
